/**
 * Genius Blog Template JavaScript
 * Version: 1.0
 */

// Initialize blog functionality when DOM is loaded or when Shopify section is loaded
document.addEventListener('DOMContentLoaded', initBlog);
document.addEventListener('shopify:section:load', initBlog);

function initBlog() {
  // Category Slider functionality
  initCategorySlider();
  
  // Flash navigation effect
  initFlashNavigation();
  
  // Article animations
  initArticleAnimations();
  
  // Create flash overlay if it doesn't exist
  if (!document.querySelector('.flash-overlay')) {
    const flashOverlay = document.createElement('div');
    flashOverlay.className = 'flash-overlay';
    document.body.appendChild(flashOverlay);
  }
}

/**
 * Initialize the category slider
 */
function initCategorySlider() {
  const sliderTrack = document.querySelector('.category-slider__track');
  const prevArrow = document.querySelector('.category-slider__arrow--prev');
  const nextArrow = document.querySelector('.category-slider__arrow--next');
  const categoryItems = document.querySelectorAll('.category-slider__item');
  
  if (!sliderTrack || !prevArrow || !nextArrow || categoryItems.length === 0) {
    console.log('Category slider elements not found');
    return;
  }
  
  const itemWidth = categoryItems[0].offsetWidth + 20; // width + margin
  const visibleItems = Math.floor(sliderTrack.parentElement.offsetWidth / itemWidth);
  const totalItems = categoryItems.length;
  let currentPosition = 0;
  
  // Initialize slider
  updateSliderPosition();
  
  // Add click event listeners to arrows
  prevArrow.addEventListener('click', function(e) {
    e.preventDefault();
    if (currentPosition > 0) {
      currentPosition--;
      updateSliderPosition();
    }
  });
  
  nextArrow.addEventListener('click', function(e) {
    e.preventDefault();
    if (currentPosition < totalItems - visibleItems) {
      currentPosition++;
      updateSliderPosition();
    }
  });
  
  // Update slider position
  function updateSliderPosition() {
    const translateX = -currentPosition * itemWidth;
    sliderTrack.style.transform = `translateX(${translateX}px)`;
    
    // Update arrow states
    prevArrow.disabled = currentPosition === 0;
    prevArrow.style.opacity = currentPosition === 0 ? '0.5' : '1';
    
    nextArrow.disabled = currentPosition >= totalItems - visibleItems;
    nextArrow.style.opacity = currentPosition >= totalItems - visibleItems ? '0.5' : '1';
    
    console.log('Slider position updated:', translateX);
  }
  
  // Add window resize event listener to update slider
  window.addEventListener('resize', function() {
    const newVisibleItems = Math.floor(sliderTrack.parentElement.offsetWidth / itemWidth);
    if (newVisibleItems !== visibleItems && currentPosition > totalItems - newVisibleItems) {
      currentPosition = Math.max(0, totalItems - newVisibleItems);
      updateSliderPosition();
    }
  });
}

/**
 * Initialize flash navigation effect
 */
function initFlashNavigation() {
  // Create flash overlay if it doesn't exist
  let flashOverlay = document.querySelector('.flash-overlay');
  if (!flashOverlay) {
    flashOverlay = document.createElement('div');
    flashOverlay.className = 'flash-overlay';
    document.body.appendChild(flashOverlay);
    console.log('Flash overlay created');
  }
  
  const categoryItems = document.querySelectorAll('.category-slider__item');
  if (!categoryItems.length) {
    console.log('Category items not found');
    return;
  }
  
  // Feature images are now always visible
  console.log('Feature images always visible');
  
  // Add click handlers to category items
  categoryItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      const category = this.getAttribute('data-category');
      console.log('Category clicked:', category);
      
      // Find the category section
      const categorySection = document.querySelector(`.blog-category[data-category="${category}"]`);
      if (!categorySection) {
        console.log('Category section not found for:', category);
        return;
      }
      
      console.log('Navigating to section:', category);
      
      // Activate flash overlay
      flashOverlay.classList.add('flash-overlay--active');
      
      // Feature images are now always visible
      
      // Wait for flash to reach full opacity
      setTimeout(() => {
        // Scroll instantly to the category section
        window.scrollTo({
          top: categorySection.offsetTop - 80,
          behavior: 'auto' // Instant scrolling
        });
        
        // Feature images are now always visible
        console.log('Navigating to category:', category);
        
        // Fade out the flash overlay
        setTimeout(() => {
          flashOverlay.classList.remove('flash-overlay--active');
        }, 500);
      }, 300);
    });
  });
}

/**
 * Initialize article animations
 */
function initArticleAnimations() {
  // Add animation for article cards on scroll
  const animateOnScroll = function() {
    const articleCards = document.querySelectorAll('.article-card');
    
    if (!articleCards.length) {
      console.log('No article cards found for animation');
      return;
    }
    
    articleCards.forEach(card => {
      const cardPosition = card.getBoundingClientRect().top;
      const screenPosition = window.innerHeight / 1.2;
      
      if (cardPosition < screenPosition) {
        card.classList.add('animate');
      }
    });
  };
  
  // Run animation check on load and scroll
  window.addEventListener('scroll', animateOnScroll);
  setTimeout(animateOnScroll, 500); // Run after a short delay to ensure DOM is ready
}

// Handle newsletter form submission
function initNewsletterForm() {
  const newsletterForm = document.querySelector('.blog-newsletter__form');
  
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      // Shopify handles the form submission
      // This is just for additional functionality if needed
    });
  }
}

// Initialize newsletter form when DOM is loaded
document.addEventListener('DOMContentLoaded', initNewsletterForm);
document.addEventListener('shopify:section:load', initNewsletterForm);
